import * as React from "react"
import { cn } from "@/lib/utils"

const Switch = React.forwardRef(({ className, checked, disabled, onChange, onCheckedChange, ...props }, ref) => {
  const isChecked = Boolean(checked)

  const handleClick = (e) => {
    if (disabled) return
    e.preventDefault()
    e.stopPropagation()
    const nextState = !isChecked
    if (onChange) {
      onChange({ target: { checked: nextState } })
    }
    if (onCheckedChange) {
      onCheckedChange(nextState)
    }
  }

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isChecked}
      disabled={disabled}
      onClick={handleClick}
      ref={ref}
      className={cn(
        "peer relative inline-flex !h-6 !w-11 shrink-0 items-center !rounded-full !border-0 !p-0.5 transition-colors duration-200 ease-in-out focus:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        isChecked ? "!bg-[#4C6B8B]" : "!bg-gray-300",
        className
      )}
      {...props}
    >
      <span
        className={cn(
          "pointer-events-none block !h-5 !w-5 !rounded-full !bg-white shadow-md ring-0 transition-transform duration-200 ease-in-out",
          isChecked ? "translate-x-5" : "translate-x-0"
        )}
      />
    </button>
  )
})
Switch.displayName = "Switch"

export { Switch }
